export default class Helper {

  public static formatDate(date: string) {
    return new Date(date).toLocaleDateString('de-de', {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric"
    });
  }

  public static lastselect: HTMLElement | any

  public static TableSelect(event: MouseEvent) {
    if (this.lastselect !== undefined) {
      this.lastselect.classList.remove("selected")
    }
    const target = event.target || event.currentTarget;
    let targetelement = target as HTMLElement
    if (targetelement.tagName !== "TR") {
      while (targetelement.parentElement !== null && targetelement.tagName !== "TR") {
        targetelement = targetelement.parentElement;
      }
    }
    targetelement.classList.add("selected")
    this.lastselect = targetelement;
  }
}
